'use client';
import React from 'react'
import CategoryTab from './CategoryTab'
import CategoryProduct from './CategoryProduct'
import { FilterSVG } from '@/src/ui/AllSVG';
import { useDispatch } from 'react-redux';
import { openDrawer } from '@/src/store/slices/allDrawerSlice';
import { useGetAllProductsDataQuery } from '@/src/store/rtkQueries/userGetAPI';
import { useSearchParams } from 'next/navigation';
import CategoryProductSkeleton from '@/src/ui/skeletons/CategoryProductSkeleton';

export default function CategoryContentWrapper() {
    const dispatch = useDispatch();
    const searchParams = useSearchParams();
    const sort = searchParams.get('sort') ?? undefined;
    const category = searchParams.get('category') ?? undefined;
    const sub_category = searchParams.get('sub_category') ?? undefined;
    const brand = searchParams.get('brand') ?? undefined;
    const color = searchParams.get('color') ?? undefined;
    const size = searchParams.get('size') ?? undefined;
    const min_price = searchParams.get('priceMin') ?? undefined;
    const max_price = searchParams.get('priceMax') ?? undefined;
    const search = searchParams.get('search') ?? undefined;
    const is_exclusive = searchParams.get('is_exclusive') ?? undefined;
    const { data: res, isLoading, isFetching } = useGetAllProductsDataQuery({
        category: sub_category || category,
        brand: brand,
        color: color,
        size: size,
        min_price: min_price ? Number(min_price) : undefined,
        max_price: max_price ? Number(max_price) : undefined,
        search: search,
        sort_by: sort,
        page: 1,
        limit: 20,
        is_exclusive: is_exclusive ? true : undefined,
    });
    const products = res?.data?.data ?? [];
    const pagination = res?.data?.pagination;
    // console.log('products', products);

    const handleFilterSort = () => {
        dispatch(openDrawer({ componentName: 'FilterSortDrawer', placement: 'right', data: { totalCount: pagination?.count ?? 0 }, className: 'rounded-none w-[500px]' }));
    };

    return (
        <>
            <CategoryTab  category={category ?? ''} sub_category={sub_category ?? ''} />
            <div className="vertical_padding xl">
                <div
                    className={`flex justify-end items-center gap-2 text-sm uppercase cursor-pointer`}
                    onClick={handleFilterSort}
                >
                    <FilterSVG /> Filter & Sort
                </div>
                <div className="vertical_padding">
                    {isLoading || isFetching ? (
                        <CategoryProductSkeleton count={4} />
                    ) : (
                        <CategoryProduct products={products} />
                    )}
                </div>
            </div>
        </>
    )
}
